export const SET_BACK_TO_CATALOG_URL = 'SET_BACK_TO_CATALOG_URL';

export function setBackToCatalogData(backToCatalogData) {
    return {
        type: SET_BACK_TO_CATALOG_URL,
        payload: {
            backToCatalogUrl: backToCatalogData.backToCatalogUrl,
            pageName: backToCatalogData.pageName
        }
    };
}
